import { useIntl } from 'react-intl';

import styles from './collection.module.scss';

import { ReactComponent as IconShare } from '../../../../../assets/images/share.svg';
import { copyToClipboard, getParameterByName } from '../../../../../utils';
import pushToDataLayer from '../../../../../utils/pushToDataLayer';
import Button, { ButtonKind } from '../../button/Button';
import Tooltip from '../../tooltip';

const ShareButton = ({ isHideText }: { isHideText?: boolean }) => {
    const intl = useIntl();
    const regex = new RegExp('[?&]seltype(=([^&#]*)|&|#|$)');
    const typeParamArray = regex.exec(window.location.href) ?? ['', '', ''];
    const typeParam = decodeURIComponent(typeParamArray[2] ?? '');
    const regex2 = new RegExp('[?&]collection(=([^&#]*)|&|#|$)');
    const collectionStringArray = regex2.exec(window.location.href) ?? ['', '', ''];
    const collectionString = decodeURIComponent(collectionStringArray[2] ?? '');
    let newHref = window.location.href;
    if (collectionString) {
        const collectionArray = collectionString.split(',');
        let puredigital = true;
        for (const collectionItem of collectionArray) {
            const urnParts = collectionItem.split(':');
            if ((urnParts.length > 1 && urnParts[0] != 'it21/dn') || (typeParam != 'digital' && urnParts.length == 1)) {
                puredigital = false;
                break;
            }
        }
        let newCollectionString = '';
        collectionArray.map(collectionItem => {
            const urnParts = collectionItem.split(':');
            const parts = urnParts.length;
            const partsIndex = parts > 2 ? 2 : parts - 1;
            newCollectionString += newCollectionString == '' ? collectionStringArray[0].substring(0, 12) : ',';
            newCollectionString += puredigital
                ? urnParts[partsIndex]
                : urnParts[0] != 'it21/dn'
                ? urnParts[partsIndex]
                : 'it21/dn::' + urnParts[partsIndex];
        });
        if (typeParam == 'digital' && !puredigital) {
            newHref = newHref.replace(typeParamArray[0], '');
        }
        if (typeParam != 'digital' && puredigital) {
            newHref += '&seltype=digital';
        }
        newHref = newHref.replace(collectionStringArray[0], newCollectionString);
    }

    return (
        <Tooltip
            message={intl.formatMessage({ id: 'collection.linkCopied', defaultMessage: 'Link kopiert!' })}
            position={'top'}
        >
            <Button
                kind={ButtonKind.LINK}
                className={styles.shareBtn}
                onClick={async () => {
                    pushToDataLayer('pf_collection_share_click');
                    await copyToClipboard(newHref);
                }}
            >
                <IconShare />
                {isHideText ? '' : intl.formatMessage({ id: 'collection.shareButton', defaultMessage: 'Auswahl teilen' })}
            </Button>
        </Tooltip>
    );
};

export default ShareButton;
